import React from 'react';
import { Link } from 'react-router-dom';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import Icons from '../Icons/Icons';
import style from './style.module.css';

interface MenuItemProps {
  icon: IconProp;
  label: string;
  link: string;
  click?: React.MouseEventHandler<HTMLAnchorElement> | React.MouseEventHandler<HTMLSpanElement>;
  flag?: string | boolean;
  type?: 'link' | boolean;
  mode?: 'light' | 'dark'; 
}

const MenuItem: React.FC<MenuItemProps> = ({
  icon, label, link, click, flag, type = false, mode = 'dark'
}) => {

  const renderContent = () => (
    <>
      <div className={style.menuItemIcon}>
        <Icons icon={icon} />
      </div>
      <div className={style.menuItemLabel} >
        {flag && <span>{flag}</span>} {label}
      </div>
    </>
  );

  return (
    <div className={`${style.menuItem} ${mode === 'dark' ? '' : style.light}`}>
      {type === 'link' ? (
        <a href={link} target="_blank" rel="noopener noreferrer">
          {renderContent()}
        </a>
      ) : (
        <Link to={link} onClick={click}>
          {renderContent()}
        </Link>
      )}
    </div>
  );
};

export default MenuItem;
